<section class="container">
	<lvr-heading class="text-inverse">
		<span>
			<mat-icon aria-hidden="true" fontIcon="assignment" class="material-symbols-outlined"></mat-icon>
			{{ 'user.specialists_overview.title' | transloco }}
		</span>
	</lvr-heading>

	<h3 class="text-inverse">{{ 'user.specialists_overview.active_specialists' | transloco }}{{ totalItems() }}</h3>
	<div class="card-grid-container">
		@if (users().length === 0) {
			<p>{{ 'user.specialists_overview.no_specialists' | transloco }}</p>
		} @else {
			<div class="card-grid">
				@for (user of users(); track user.id) {
					<lvr-specialist-card [user]="user"></lvr-specialist-card>
				}
			</div>
		}
	</div>
	<lvr-paginator
		[length]="totalItems()"
		[pageSize]="pageSize()"
		[pageIndex]="pageIndex()"
		[showFirstLastButtons]="showFirstLastButtons"
		[hidePageSize]="hidePageSize"
		preferenceKey="specialists-overview"
		(page)="handlePageEvent($event)"
	>
	</lvr-paginator>
</section>
